import { render, staticRenderFns } from "./CategoryBenefitsTable.vue?vue&type=template&id=0d490db2&"
import script from "./CategoryBenefitsTable.vue?vue&type=script&lang=js&"
export * from "./CategoryBenefitsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports